export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    getAssetsURL: () => process.env.VUE_APP_ASSETS_URL,
  },
};
